export enum CheckoutStatus {
    open = "open", 
    completed = "complete",
    expired= "expired"
}